require("./../sass/base.scss");

$(function () {
  const $signupPromptModal = $("#signup-prompt-modal");

  function closeSignupModal() {
    $signupPromptModal.removeClass("is-active");
  }

  function openSignupModal(message) {
    const defaultMessage = "Join diff.blog";
    const joinMessageElement = document.getElementById("join-message");
    if (joinMessageElement) {
      joinMessageElement.innerText = message || defaultMessage;
    }
    $signupPromptModal.addClass("is-active");
  }

  window.openSignupModal = openSignupModal;

  $(
    "#signup-prompt-modal .modal-close, #signup-prompt-modal .modal-background"
  ).on("click", function () {
    closeSignupModal();
  });

  $(document).on("click", ".js-open-signup-modal", function (event) {
    event.preventDefault();
    openSignupModal($(this).data("joinMessage"));
  });

  // ---- navbar drawers --------------------------------------------------
  // Topics (left) and menu (right) are the same component mirrored, so they
  // share one open/close path and one scrim.
  const $scrim = $("#dbnav-scrim");

  const drawers = [
    {
      $panel: $("#dbnav-topics-drawer"),
      $btn: $("#dbnav-topics-btn"),
      $close: $("#dbnav-topics-close"),
    },
    {
      $panel: $("#dbnav-menu-drawer"),
      $btn: $("#dbnav-menu-btn"),
      $close: $("#dbnav-menu-close"),
    },
  ].filter(function (d) {
    return d.$panel.length > 0;
  });

  function setDrawer(target, open) {
    if (open) {
      // Only one at a time — opening either closes the other.
      drawers.forEach(function (d) {
        if (d !== target) {
          d.$panel.removeClass("is-open");
          d.$btn.attr("aria-expanded", "false");
        }
      });
    }
    target.$panel.toggleClass("is-open", open);
    target.$btn.attr("aria-expanded", String(open));
    $scrim.toggleClass("is-open", open);
    $("body").toggleClass("dbnav-locked", open);
  }

  function closeAll() {
    drawers.forEach(function (d) {
      d.$panel.removeClass("is-open");
      d.$btn.attr("aria-expanded", "false");
    });
    $scrim.removeClass("is-open");
    $("body").removeClass("dbnav-locked");
  }

  drawers.forEach(function (d) {
    d.$btn.on("click", function () {
      setDrawer(d, !d.$panel.hasClass("is-open"));
    });
    d.$close.on("click", function () {
      setDrawer(d, false);
    });
    // Following a link navigates, but close first so a cached
    // back-navigation doesn't land on an open drawer.
    d.$panel.on("click", "a", function () {
      setDrawer(d, false);
    });
  });

  $scrim.on("click", closeAll);

  $(document).on("keydown", function (event) {
    if (event.key === "Escape") {
      closeAll();
    }
  });
});
